export default "__VITE_ASSET__D4rloUFS__"